import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import host from "../../config";

const Yendada = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // Only depends on id

  // const images = [
  //   "/images/image11.jpeg",
  //   "/images/image9.jpeg",
  // ];

  const pricingData = [
    {
      id: 1,
      TypeofBooking:"Yendada-slot1(6 AM-2 PM)",
      purpose:
        "Birthday functions and other Official / Corporate meetings / Get-together functions (General Public)",

      rent: 50000,
      deposit: 30000,
      gst: 10800,
      cleaning: 10000,
      total: 100800,
    },
  {
      id: 2,
      TypeofBooking:"Yendada-slot2(4 PM-10 PM)",
      purpose:
        "Birthday functions and other Official / Corporate meetings / Get-together functions (General Public)",

      rent: 50000,
      deposit: 30000,
      gst: 10800,
      cleaning: 10000,
      total: 100800,
    },
      {
      id: 3,
      TypeofBooking:"Yendada-slot3(10 PM-5 AM)",
      purpose:
        "Birthday functions and other Official / Corporate meetings / Get-together functions (General Public)",

      rent: 43750,
      deposit: 30000,
      gst: 9675,
      cleaning: 10000,
      total: 93425,
    },
     {
      id: 4,
      TypeofBooking:"Yendada Full slot",
      purpose:
        "Birthday functions and other Official / Corporate meetings / Get-together functions (General Public)",

      rent: 150000,
      deposit:60000,
      gst: 28800,
      cleaning: 10000,
      total:248800 ,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        {/* Hero Section */}
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.map((item, idx) => (
              <div key={idx} className="carousel-image">
                <img
                  src={item.url}
                  alt={`Conventions Center, Yendada Image ${idx + 1}`}
                />
                <div className="overlay">
                  <h1>Conventions Center, Yendada</h1>
                  <p>Perfect Venue for Social and Corporate Events</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {/* Venue Details */}
        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Conventions Center, Yendada</strong> is a serene venue ideal
            for birthday functions, corporate meetings, and get-together events.
            It provides modern amenities and a peaceful environment for your
            special occasions.
          </p>

          {/* Pricing Section */}
          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
              <h4>{item.TypeofBooking}</h4>
                <h5>{item.purpose}</h5>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          {/* Contact Section */}
          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Conventions Center, Yendada,
              Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@vmrda.com
            </p>
          </div>

          {/* Book Now Button */}
          <Link to="/" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Yendada;
